import store from '@store/index';
import { setConfirmDialog } from '@store/appStore';

interface ConfirmButton {
    text: string;
    onPress: () => void;
    style?: 'default' | 'cancel' | 'destructive';
}

interface ConfirmOptions {
    title: string;
    message: string;
    buttons?: ConfirmButton[];
    hideCloseButton?: boolean;
}

export const showIOSAlert = (options: ConfirmOptions) => {
    const defaultButtons: ConfirmButton[] = options.buttons || [
        {
            text: 'OK',
            onPress: () => {},
            style: 'default'
        }
    ];

    store.dispatch(
        setConfirmDialog({
            open: true,
            buttons: defaultButtons,
            hideCloseButton: options.hideCloseButton || false,
            ...options
        })
    );
};
